import {LobbyHeaderDefaultBox} from "./lobby-header.default.box";
import {styledByTheme} from "../../../themes/architecture/styled-by-theme";
import {LobbyHeaderSiBox} from "./lobby-header.si.box";
import {LobbyHeaderMrGreenBox} from "./lobby-header.mrgreen.box";
import {LobbyHeaderWsopBox} from "./lobby-header.wsop.box";

export const LobbyHeaderBox = styledByTheme(LobbyHeaderDefaultBox)
    .forSI(LobbyHeaderSiBox)
    .forMrGreen(LobbyHeaderMrGreenBox)
    .forWsop(LobbyHeaderWsopBox)
    .apply();
